// extracted by mini-css-extract-plugin
export default {"sidebar-panel":"styles_sidebar-panel__N9Jov","inline-code":"styles_inline-code__aFVrO","hint":"styles_hint__R7Vla","separator":"styles_separator__Hgp5r"};